<template>
 <div class="resource-companyProfile-honorsAwards">
  <div class="resource-companyProfile-honorsAwards-title honorsAwards_box">荣誉奖项</div>
  <div class="resource-companyProfile-honorsAwards-content">
   <div class="resource-companyProfile-honorsAwards-content-item honorsAwards_box" v-for="(item, index) in imageList"
    :key="index">
    <div class="resource-companyProfile-honorsAwards-content-item-img">
     <img :src="item.url" alt="" style="width: 100%; height: 100%;" />
    </div>

   </div>
  </div>
  <div class="resource-companyProfile-honorsAwards-content-mobile">
   <div class="resource-companyProfile-honorsAwards-content-item-mobile  honorsAwards_box"
    v-for="(item, index) in imageListMobile" :key="index">
    <div class="resource-companyProfile-honorsAwards-content-item-img">
     <img :src="item.url" alt="" style="width: 100%; height: 100%;" />
    </div>

   </div>
  </div>
 </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { getFilterList } from "@/api/index"
import ScrollReveal from 'scrollreveal'
const dataList = ref([])

const imageList = ref([
 {
  url: require('../../../assets/image/resource/gxrz.png')
 },
 {
  url: require('../../../assets/image/resource/ios.png')
 },
 {
  url: require('../../../assets/image/resource/zjtx.png')
 },
 {
  url: require('../../../assets/image/resource/zxxqy.png')
 },
 {
  url: require('../../../assets/image/resource/cxx.png')
 },
 {
  url: require('../../../assets/image/resource/qdzx.png')
 },
 {
  url: require('../../../assets/image/resource/zgc.png')
 },
 {
  url: require('../../../assets/image/resource/cmmi.png')
 },
 {
  url: require('../../../assets/image/resource/itss.png')
 },
 {
  url: require('../../../assets/image/resource/ft.png')
 },
 {
  url: require('../../../assets/image/resource/hwy.png')
 },
 {
  url: require('../../../assets/image/resource/hwjsrz.png')
 },
 {
  url: require('../../../assets/image/resource/bsia.png')
 },
 {
  url: require('../../../assets/image/resource/shuangruan.png')
 },
 {
  url: require('../../../assets/image/resource/dxkj.png')
 },
 {
  url: require('../../../assets/image/resource/zgcls.png')
 },
 {
  url: require('../../../assets/image/resource/xiz.png')
 },
 {
  url: require('../../../assets/image/resource/zgxd.png')
 },
])

const imageListMobile = ref([
 {
  url: require('../../../assets/image/resource_bg/gxrz.png')
 },
 {
  url: require('../../../assets/image/resource_bg/ios.png')
 },
 {
  url: require('../../../assets/image/resource_bg/zjtx.png')
 },
 {
  url: require('../../../assets/image/resource_bg/zxxqy.png')
 },
 {
  url: require('../../../assets/image/resource_bg/cxx.png')
 },
 {
  url: require('../../../assets/image/resource_bg/qdzx.png')
 },
 {
  url: require('../../../assets/image/resource_bg/zgc.png')
 },
 {
  url: require('../../../assets/image/resource_bg/cmmi.png')
 },
 {
  url: require('../../../assets/image/resource_bg/itss.png')
 },
 {
  url: require('../../../assets/image/resource_bg/ft.png')
 },
 {
  url: require('../../../assets/image/resource_bg/hwy.png')
 },
 {
  url: require('../../../assets/image/resource_bg/hwjsrz.png')
 },
 {
  url: require('../../../assets/image/resource_bg/bsia.png')
 },
 {
  url: require('../../../assets/image/resource_bg/shuangruan.png')
 },
 {
  url: require('../../../assets/image/resource_bg/dxkj.png')
 },
 {
  url: require('../../../assets/image/resource_bg/zgcls.png')
 },
 {
  url: require('../../../assets/image/resource_bg/xiz.png')
 },
 {
  url: require('../../../assets/image/resource_bg/zgxd.png')
 },
])



const getImgUrl = (item) => {
 if (item['picture-upload647378df'] && item['picture-upload647378df'].length > 0) {
  return item['picture-upload647378df'][0].url
 } else {
  return ""

 }
}

const getTitle = (props) => {
 let info = dataList.value[props.i]
 if (info) {
  return info['input988275a1']
 } else {
  return ""
 }
}
const getData = async () => {
 let params = {
  page: 1,
  pageSize: 10000,
  sortField: "number1a526476",
  isAsc: true,
  worksheetId: "681ad13c515de26d77266aae",
 }
 const res = await getFilterList(params)
 if (res.code === 200 && res.data && res.data.length > 0) {
  dataList.value = res.data
 }
}

onMounted(() => {
 // getData()
 const sr = ScrollReveal({
  distance: '50px',
  duration: 1000,
  delay: 300,
 })

 // 为每个元素配置不同的动画
 sr.reveal(".honorsAwards_box", {
  beforeReveal: (el) => {
   el.classList.add('animate__fadeInUp')
  },
 })
})
</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .resource-companyProfile-honorsAwards-content {
  display: none !important;
 }

 .resource-companyProfile-honorsAwards-content-mobile {
  display: flex !important;
 }

 .resource-companyProfile-honorsAwards {
  padding-left: 0 !important;
  padding-right: 0 !important;
 }
}



@media screen and (min-width: 800px) {
 .resource-companyProfile-honorsAwards-content {
  display: grid !important;
 }

 .resource-companyProfile-honorsAwards-content-mobile {
  display: none !important;
 }

 .resource-companyProfile-honorsAwards {
  padding-left: 18%;
  padding-right: 18%;
 }
}

.resource-companyProfile-honorsAwards {
 width: 100%;
 height: 100%;
 padding-left: 18%;
 padding-right: 18%;
}

.resource-companyProfile-honorsAwards-title {
 width: 100%;
 font-size: 36px;
 font-family: 'PuHuiTi';
 margin-top: 20px;
 margin-bottom: 20px;
 display: flex;
 justify-content: center;
}

.resource-companyProfile-honorsAwards-content {
 width: 100%;
 height: 100%;
 // display: flex;
 // flex-wrap: wrap;
 display: grid;
 justify-content: space-between;
 grid-template-columns: repeat(auto-fill, 152px);
 grid-gap: 10px;
 margin: 30px 0;
}

.resource-companyProfile-honorsAwards-content-mobile {
 width: 100%;
 height: 100%;
 // display: flex;
 // flex-wrap: wrap;
 display: grid;
 justify-content: space-around;
 flex-wrap: wrap;
 grid-gap: 0px;
 margin: 30px 0;
}

.resource-companyProfile-honorsAwards-content-item {
 width: 165px;
 height: 165px;
 margin: 10px;
 border: 1px solid transparent;
 // background: linear-gradient(white, white) padding-box,
 //  repeating-linear-gradient(-45deg, #ccc 0, #ccc 0.5em, white 0, white 0.75em);

 // display: flex;
 // flex-direction: column;
 // align-items: center;

 // padding-top: 12px;

}

.resource-companyProfile-honorsAwards-content-item-mobile {
 width: 32rem;
 height: 119px;
 margin: 10px 0;
 border: 1px solid transparent;
 // background: linear-gradient(white, white) padding-box,
 //  repeating-linear-gradient(-45deg, #ccc 0, #ccc 0.5em, white 0, white 0.75em);

 // display: flex;
 // flex-direction: column;
 // align-items: center;



}

.resource-companyProfile-honorsAwards-content-item-img {
 width: 100%;
 height: 100%;
}
</style>